import moment from 'moment';
import * as _ from "underscore";
import * as env_config from './config/config.json'

export const periods = ["ON", "1W", "1M", "2M", "3M", "6M", "12M"];
export const indexPeriods = ["0D", "5D"];
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const loadArr = { "ON": '', "1W": '', "1M": '', "2M": '', "3M": '', "6M": '', "12M": '' }
export const indexArr = { "0D": '', "5D": '' }
export const loadArrFalse = { "ON": false, "1W": false, "1M": false, "2M": false, "3M": false, "6M": false, "12M": false }
export const loadArrTrue = { "ON": true, "1W": true, "1M": true, "2M": true, "3M": true, "6M": true, "12M": true }
export const COOKIE_PREFERENCE = 'rfr_pref';
export const GA_TRACKING_ID = env_config['gaTrakingId']
export const captcha_site_key = env_config['captcha_site_key']
export const OPTAN_ON_CONSENT = 'OptanonConsent';

export const getGaObjectsDimension = (index) => {
    return {
        "stdEndDate": index + " Standard Tenors - End Date",
        "stdLag": index + " Standard Tenors - Lag",
        "calcStartDate": index + " Calculator - Start Date",
        "calcEndDate": index + " Calculator - End Date",
        "calcLag": index + " Calculator - Lag",
        "calcRounding": index + " Calculator - Rounding",
        "indexDate": index + " RRIX Indices - Date",
        "dateCountConvention": index + " Date Count Convention",
        "endDateAdjustment": index + " End Date Adjustment",
        "couponRoundingRule": index + " Coupon Rounding Rule",
        "PaymentHolidays": index + " Payment Holidays",
        "resetType": index + " Reset Type"
    }
}

const instrument_type_mapping = {
    "SONIA" : "SONIA",
    "SOFR" : "SOFR",
    "€STR" : "ESTR",
    "TONAR" : "TONAR"
}

export {env_config};
export const VAR_BASE_URL = env_config['base_url']
export const baseUrl = window.location.origin + "/";
export const riskFreeApi = "api/v2/risk_free_rate";
export const indexRiskFreeApi = "api/v2/index_risk_free_rate";
export const fallbackApi="api/v2/fallback_rate";
export const spreadDecimalPlaces = '6';

export const getStartDate = (endDate, period) => {
    var startDate = "";
    var endD = new Date(endDate);

    switch (period) {
        case "ON":
            startDate = endD.setDate(endD.getDate() - 1);
            break;
        case "1W":
            startDate = endD.setDate(endD.getDate() - 7);
            break;
        case "1M":
            startDate = endD.setMonth(endD.getMonth() - 1);
            break;
        case "2M":
            startDate = endD.setMonth(endD.getMonth() - 2);
            break;
        case "3M":
            startDate = endD.setMonth(endD.getMonth() - 3);
            break;
        case "6M":
            startDate = endD.setMonth(endD.getMonth() - 6);
            break;
        case "12M":
            startDate = endD.setMonth(endD.getMonth() - 12);
            break;
        default:
            startDate = endD;
    }
    return startDate;
}
export const getIndexName = (period, instrumentType) => {
    let name = ''
    switch (period) {
        case "0D":
            name = instrumentType+"-RRIX";
            break;
        case "5D":
            name = instrumentType+"-RRIX5 (with 5d lag)";
            break;
        default:
            name = instrumentType+"-RRIX";
    }
    return name;
}
export const getIndexLag = (period) => {
    let lag = 0
    switch (period) {
        case "0D":
            lag = 0;
            break;
        case "5D":
            lag = 5;
            break;
        default:
            lag = 0;
    }
    return lag;
}

export const customDateDdMmmYyyy = (dateString) => {
    var dateParts = dateString.split('/');

    var date = Date.UTC(
        (dateParts[2] * 1),
        (months.indexOf(dateParts[1]
        ) * 1),
        dateParts[0] * 1);
    return new Date(date);
};

export const createGridOneUrl = (instrumentType, endDate, period, lag, resetType) => {
    var instrumentType = instrument_type_mapping[instrumentType];
    var endDateM = moment(endDate).format('DD/MMM/YYYY');
    var startDate = getStartDate(endDate, period);
    var startDateM = moment(startDate).format('DD/MMM/YYYY');
    var lagP = parseLag(lag);
    var url = baseUrl + riskFreeApi + `?index=${instrumentType}&start_date=${startDateM}&end_date=${endDateM}&reset_lag=${lagP}&reset_type=${resetType}&return_type=json`
    return url;
}
export const createGridOneFallbackUrl = (instrumentType, calcDate, period) => {
    var instrumentType = instrument_type_mapping[instrumentType];
    var calcDate = moment(calcDate).format('DD/MMM/YYYY');
    var url = baseUrl + fallbackApi + `?index=${instrumentType}&calc_date=${calcDate}&tenor=${period}`
    return url;
}
export const createCustomFilterUrl = (instrumentType, startDate, endDate, round, lag, notional, spread, dayCount, endDateAdjustment, roundingRule, holidays, resetType, defaultEndDateAdjustment, defaultDayCount, defaultRoundingRule, defaultResetType, negativeInterestType, floorLvl) => {

    let dayCountParameter = ''
    let endDateAdjustmentParameter = ''
    let roundingRuleParameter = ''
    let holidaysParameter = ''
    let notionalParameter = ''
    let spreadParameter = ''
    let resetTypeParameter = ''
    let negativeInterestTypeParameter = ''
    let floorLvlParameter = ''

    if (dayCount != null && dayCount != defaultDayCount) {
        dayCountParameter = `&day_count=${dayCount}`
    }
    if (endDateAdjustment != null && endDateAdjustment != defaultEndDateAdjustment) {
        endDateAdjustmentParameter = `&end_date_adjustment=${endDateAdjustment}`
    }
    if (roundingRule != null && roundingRule != defaultRoundingRule) {
        roundingRuleParameter = `&rounding_rule=${roundingRule}`
    }

    if (holidays != null) {
        holidaysParameter = "&holiday_calendar=" + holidays.join(',');
    }

    if (spread != null && spread != '') {
        spreadParameter = `&spread=${spread}`
    }

    // thousand separator changes
    if (notional != null && notional != '') {
        notionalParameter = `&notional=${notional.replace(/,/g, '')}`
    }
    // thousand separator changes

    if (resetType != null) {
    // if (resetType != null && resetType != defaultResetType) {
        resetTypeParameter = `&reset_type=${resetType}`
    }

    if(negativeInterestType){
        negativeInterestTypeParameter = `&negative_interest_rate_type=${negativeInterestType}`
    }

    if(negativeInterestType && negativeInterestType != 'NoFloor' && floorLvl){
        floorLvlParameter = `&floor_level=${floorLvl}`
    }

    var instrumentType = instrument_type_mapping[instrumentType];
    var startDateM = moment(startDate).format('DD/MMM/YYYY');
    var lagP = parseLag(lag);
    var endDateM = moment(endDate).format('DD/MMM/YYYY');

    var url = baseUrl + riskFreeApi + `?index=${instrumentType}&start_date=${startDateM}&end_date=${endDateM}&reset_lag=${lagP}&rounding=${round}${notionalParameter}${spreadParameter}${dayCountParameter}${endDateAdjustmentParameter}${roundingRuleParameter}${holidaysParameter}${resetTypeParameter}${negativeInterestTypeParameter}${floorLvlParameter}&return_type=json`

    return url;
}

export const createIndexRateUrl = (instrumentType, endDate, item) => {
    var instrumentType = instrument_type_mapping[instrumentType];
    var endDateM = moment(endDate).format('DD/MMM/YYYY');
    var lag = getIndexLag(item);
    var url = baseUrl + indexRiskFreeApi + `?index=${instrumentType}&end_date=${endDateM}&reset_lag=${lag}&return_type=json`
    return url;
}

export const createBoeUrl = (instrumentType) => {
    var instrumentType = instrument_type_mapping[instrumentType];
    return baseUrl + `api/v2/bootstrap_data?index=${instrumentType}`;
}

export const excelViewUrl = (endDate, lastBoeDate) => {
    let requestParams = '';
    if (formatDateDDMMYYY(endDate) != formatDateDDMMYYY(customDateDdMmmYyyy(lastBoeDate)))
        requestParams = '?boe_date=' + moment(endDate).format('YYYY-MM-DD');
    return baseUrl + 'view/excel' + requestParams;
}

export const createLoginURL = () => {
    return baseUrl + 'api/is_valid_user';
}
export const parseLag = (lag) => {
    if (_.isNumber(lag))
        return lag
    return parseInt(lag.substring(0, lag.length - 1), 10);
}

export const compareDate = (date, effectDate) => {
    var effectiveDate = new Date(effectDate);
    if (date.getDate() === effectiveDate.getDate() &&
        date.getMonth() === effectiveDate.getMonth() &&
        date.getFullYear() === effectiveDate.getFullYear())
        return true;

    return false;
}

export const formatDate = (date) => {
    return "" + days[date.getDay()] + ', ' + date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear()
}

export const formatDateDDMMYYY = (date) => {
    return moment(date).format('DD MMM YYYY');
}
export const setCookie = (name) => {
    document.cookie = name + "=true; expires=Fri, 31 Dec 2100 23:59:59 GMT";
}
export const resetCookie = (name) => {
    document.cookie = name + "=false; expires=Fri, 31 Dec 2100 23:59:59 GMT";
}
export const isGaCookieEnabled = () => {
    const isAccept = document.cookie.split(';').filter(item => item.indexOf(COOKIE_PREFERENCE + '=true') >= 0).length;
    if (isAccept) {
        return true
    }
    else return false;
}

export const disableGaAnalytics = () =>{
    window['ga-disable-'+ GA_TRACKING_ID] = true;
    let  domain = "";
    const hostname = window.location.hostname;
    if(hostname.includes("localhost")){
        domain= hostname;
    }
    else if(!hostname.includes("appspot")){
        domain= '.' + hostname.split('.').slice(-2).join('.');
    }    
    else {
        domain= '.' + hostname;
    }
    document.cookie = '_ga' +'=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain='+ domain +';';
    document.cookie = '_gid' +'=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain='+ domain +';';
    const gaId = GA_TRACKING_ID.split('-').join('_');    
    document.cookie = '_gat_gtag_' + gaId+'=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain='+ domain +';';
}

export const sendGaAnalyticsEvent = (dimension, value) => {
    if (isGaCookieEnabled()) {
        let payload = {}
        payload[dimension] = value;
        const action = dimension;
        window.gtag('event', action, payload);
    }
}
export const URLParametersExtractor =(url, param) =>{
    var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(url);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}

// thousand separator changes
export const ValidateInteger = (value) => {
    const regx = /^[0-9,]*$/;
    return regx.test(value);
}
// thousand separator changes

export const validateNumberWithDecimalPlaces = (value, decimalPlaces) => {
    var pattern = '^[0-9]+\.?[0-9]{0,'+decimalPlaces+'}$';
    const regx = new RegExp(pattern);
    return regx.test(value);
}


// WEBPACK FOOTER //
// ./src/util.js